import React, { useEffect } from "react";
import MultiSelectField from "../../../MultiSelectField";
import { useTmsMetadata } from "../../hooks/useTmsMetadata";

const TmsMetadataSection = ({
  enabled,
  values,
  onChange,
  selectedVerticalIds = [],
  clientId = null,
  onLoadingChange,
  onError
}) => {
  const hasClientId =
    clientId !== null && clientId !== undefined && clientId !== "";
  const {
    documentTypes,
    verticals,
    productLines,
    disciplines,
    loading,
    disciplinesLoading,
    disciplinesError
  } = useTmsMetadata(enabled ? selectedVerticalIds : [], clientId);

  useEffect(() => {
    if (typeof onLoadingChange === "function") {
      onLoadingChange(loading || disciplinesLoading);
    }
  }, [loading, disciplinesLoading, onLoadingChange]);

  useEffect(() => {
    if (disciplinesError && typeof onError === "function") {
      onError("Unable to load disciplines. Please try again later.");
    }
  }, [disciplinesError, onError]);

  if (!enabled) {
    return null;
  }

  const handleChange = (field) => (selection) => {
    onChange(field, selection || []);
  };

  return (
    <>
      <MultiSelectField
        label="Document Types"
        placeholder="Select document types"
        value={values.documentTypeIds}
        options={documentTypes}
        onChange={handleChange("documentTypeIds")}
        noOptionsText="No document types"
      />

      <MultiSelectField
        label="Verticals"
        placeholder="Select verticals"
        value={values.verticalIds}
        options={verticals}
        onChange={handleChange("verticalIds")}
        noOptionsText="No verticals"
      />

      <MultiSelectField
        label="Disciplines"
        placeholder="Select disciplines"
        value={values.disciplineIds}
        options={disciplines}
        onChange={handleChange("disciplineIds")}
        noOptionsText="No disciplines"
      />

      <MultiSelectField
        label="Product Lines"
        placeholder="Select product lines"
        value={values.productLineIds}
        options={productLines}
        onChange={handleChange("productLineIds")}
        noOptionsText="No product lines"
        disabled={!hasClientId}
      />
    </>
  );
};

export default TmsMetadataSection;
